<template>
  <div class="side-content-wrap">
    <div
      class="sidebar-left open rtl-ps-none"
      data-perfect-scrollbar=""
      data-suppress-scroll-x="true"
    >
      <ul class="navigation-left">
        <li class="nav-item">
          <router-link class="nav-item-hold" to="/dashboard"
            ><i class="nav-icon i-Bar-Chart"></i
            ><span class="nav-text">Dashboard</span></router-link
          >
          <div class="triangle"></div>
        </li>
        <li
          class="nav-item"
          data-item="Authentications"
          v-if="roleuserModules.includes(3) === true"
        >
          <a class="nav-item-hold" href="#"
            ><i class="nav-icon i-Administrator"></i
            ><span class="nav-text">Authentications</span></a
          >
          <div class="triangle"></div>
        </li>
        <li
          class="nav-item"
          data-item="products"
          v-if="roleuserModules.includes(4) === true"
        >
          <a class="nav-item-hold" href="#"
            ><i class="nav-icon i-Bag-Items"></i
            ><span class="nav-text">Products</span></a
          >
          <div class="triangle"></div>
        </li>
        <li
          class="nav-item"
          data-item="suppliers"
          v-if="roleuserModules.includes(13) === true"
        >
          <a class="nav-item-hold" href="#"
            ><i class="nav-icon i-Bag-Items"></i
            ><span class="nav-text">Suppliers</span></a
          >
          <div class="triangle"></div>
        </li>
        <li
          class="nav-item"
          data-item="stocks"
          v-if="roleuserModules.includes(5) === true"
        >
          <a class="nav-item-hold" href="#"
            ><i class="nav-icon i-Bag-Items"></i
            ><span class="nav-text">Stocks</span></a
          >
          <div class="triangle"></div>
        </li>
        <li
          class="nav-item"
          data-item="transporters"
          v-if="roleuserModules.includes(6) === true"
        >
          <a class="nav-item-hold" href="#"
            ><i class="nav-icon i-Bag-Items"></i
            ><span class="nav-text">Transporters</span></a
          >
          <div class="triangle"></div>
        </li>
        <li
          class="nav-item"
          data-item="goodsreceiving"
          v-if="roleuserModules.includes(8) === true"
        >
          <a class="nav-item-hold" href="#"
            ><i class="nav-icon i-Bag-Items"></i
            ><span class="nav-text">GoodsReceiving</span></a
          >
          <div class="triangle"></div>
        </li>
        <li
          class="nav-item"
          data-item="salesettings"
          v-if="roleuserModules.includes(10) === true"
        >
          <a class="nav-item-hold" href="#"
            ><i class="nav-icon i-Bag-Items"></i
            ><span class="nav-text">SaleSettings</span></a
          >
          <div class="triangle"></div>
        </li>
        <li
          class="nav-item"
          data-item="mileages"
          v-if="roleuserModules.includes(15) === true"
        >
          <a class="nav-item-hold" href="#"
            ><i class="nav-icon i-Bag-Items"></i
            ><span class="nav-text">Mileage</span></a
          >
          <div class="triangle"></div>
        </li>
        <li
          class="nav-item"
          data-item="trips"
          v-if="roleuserModules.includes(17) === true"
        >
          <a class="nav-item-hold" href="#"
            ><i class="nav-icon i-Bag-Items"></i
            ><span class="nav-text">Trips</span></a
          >
          <div class="triangle"></div>
        </li>
        <li
          class="nav-item"
          data-item="accounts"
          v-if="roleuserModules.includes(7) === true"
        >
          <a class="nav-item-hold" href="#"
            ><i class="nav-icon i-Bag-Items"></i
            ><span class="nav-text">Accounts</span></a
          >
          <div class="triangle"></div>
        </li>
        <li
          class="nav-item"
          data-item="reports"
          v-if="roleuserModules.includes(11) === true"
        >
          <a class="nav-item-hold" href="#"
            ><i class="nav-icon i-Bag-Items"></i
            ><span class="nav-text">Reports</span></a
          >
          <div class="triangle"></div>
        </li>
      </ul>
    </div>
    <div
      class="sidebar-left-secondary rtl-ps-none"
      data-perfect-scrollbar=""
      data-suppress-scroll-x="true"
    >
      <!-- chartjs-->
      <ul class="childNav" data-parent="Authentications">
        <li class="nav-item dropdown-sidemenu">
          <a href=""
            ><i class="nav-icon i-File-Clipboard-Text--Image"></i
            ><span class="item-name">Roles</span
            ><i class="dd-arrow i-Arrow-Down"></i
          ></a>
          <ul class="submenu">
            <li><router-link to="/role">New role</router-link></li>
            <li><router-link to="/managerole">Manage roles</router-link></li>
          </ul>
        </li>
        <li class="nav-item dropdown-sidemenu">
          <a href=""
            ><i class="nav-icon i-File-Clipboard-Text--Image"></i
            ><span class="item-name">Modules</span
            ><i class="dd-arrow i-Arrow-Down"></i
          ></a>
          <ul class="submenu">
            <li><router-link to="/newmodule">New module</router-link></li>
            <li>
              <router-link to="/managemodules">Manage modules</router-link>
            </li>
          </ul>
        </li>
        <li class="nav-item dropdown-sidemenu">
          <a href=""
            ><i class="nav-icon i-File-Clipboard-Text--Image"></i
            ><span class="item-name">Permissions</span
            ><i class="dd-arrow i-Arrow-Down"></i
          ></a>
          <ul class="submenu">
            <li><router-link to="/permission">New permission</router-link></li>
            <li>
              <router-link to="/managepermissions"
                >Manage permissions</router-link
              >
            </li>
          </ul>
        </li>
        <li class="nav-item dropdown-sidemenu">
          <a href=""
            ><i class="nav-icon i-File-Clipboard-Text--Image"></i
            ><span class="item-name">System users</span
            ><i class="dd-arrow i-Arrow-Down"></i
          ></a>
          <ul class="submenu">
            <li><router-link to="/newuser">New users</router-link></li>
            <li><router-link to="/manageusers">Manage users</router-link></li>
          </ul>
        </li>
      </ul>
      <ul class="childNav" data-parent="products">
        <li class="nav-item dropdown-sidemenu">
          <a href=""
            ><i class="nav-icon i-File-Clipboard-Text--Image"></i
            ><span class="item-name">Products</span
            ><i class="dd-arrow i-Arrow-Down"></i
          ></a>
          <ul class="submenu">
            <li><router-link to="/newproduct">New product</router-link></li>
            <li>
              <router-link to="/manageproducts">Manage products</router-link>
            </li>
          </ul>
        </li>
      </ul>
      <ul class="childNav" data-parent="suppliers">
        <li class="nav-item dropdown-sidemenu">
          <a href=""
            ><i class="nav-icon i-File-Clipboard-Text--Image"></i
            ><span class="item-name">Suppliers</span
            ><i class="dd-arrow i-Arrow-Down"></i
          ></a>
          <ul class="submenu">
            <li><router-link to="/supplier">New supplier</router-link></li>
            <li>
              <router-link to="/managesuppliers">Manage suppliers</router-link>
            </li>
          </ul>
        </li>
      </ul>
      <ul class="childNav" data-parent="stocks">
        <li class="nav-item dropdown-sidemenu">
          <a href=""
            ><i class="nav-icon i-File-Clipboard-Text--Image"></i
            ><span class="item-name">Stocks</span
            ><i class="dd-arrow i-Arrow-Down"></i
          ></a>
          <ul class="submenu">
            <li><router-link to="/stock">New stock</router-link></li>
            <li><router-link to="/managestocks">Manage stocks</router-link></li>
            <li>
              <router-link to="/managedeadstocks"
                >Manage dead stocks</router-link
              >
            </li>
          </ul>
        </li>
      </ul>
      <ul class="childNav" data-parent="transporters">
        <li class="nav-item dropdown-sidemenu">
          <a href=""
            ><i class="nav-icon i-File-Clipboard-Text--Image"></i
            ><span class="item-name">Transporters</span
            ><i class="dd-arrow i-Arrow-Down"></i
          ></a>
          <ul class="submenu">
            <li>
              <router-link to="/newtransporter">New transporter</router-link>
            </li>
            <li>
              <router-link to="/managetransporters"
                >Manage transporters</router-link
              >
            </li>
            <li>
              <router-link to="/managetrucks">Manage trucks</router-link>
            </li>
            <li>
              <router-link to="/managejobcards">Manage jobcards</router-link>
            </li>
            <li>
              <router-link to="/managetruckattendances"
                >Manage truckattendances</router-link
              >
            </li>
          </ul>
        </li>
      </ul>
      <ul class="childNav" data-parent="goodsreceiving">
        <li class="nav-item dropdown-sidemenu">
          <a href=""
            ><i class="nav-icon i-File-Clipboard-Text--Image"></i
            ><span class="item-name">GoodsReceiving</span
            ><i class="dd-arrow i-Arrow-Down"></i
          ></a>
          <ul class="submenu">
            <li><router-link to="/receivegoods">Receive goods</router-link></li>
            <li>
              <router-link to="/managegoodsreceiving"
                >Manage goods received</router-link
              >
            </li>
          </ul>
        </li>
      </ul>
      <ul class="childNav" data-parent="salesettings">
        <li class="nav-item dropdown-sidemenu">
          <a href=""
            ><i class="nav-icon i-File-Clipboard-Text--Image"></i
            ><span class="item-name">SaleSettings</span
            ><i class="dd-arrow i-Arrow-Down"></i
          ></a>
          <ul class="submenu">
            <li>
              <router-link to="/managejobcardsales"
                >Jobcard sales & labour</router-link
              >
            </li>
            <li><router-link to="/managesales">Manage sales</router-link></li>
            <li>
              <router-link to="/newdefectivesale"
                >New defective sales</router-link
              >
            </li>
            <li>
              <router-link to="/managedeadsales"
                >Manage defective sales</router-link
              >
            </li>
          </ul>
        </li>
      </ul>
      <ul class="childNav" data-parent="mileages">
        <li class="nav-item dropdown-sidemenu">
          <a href=""
            ><i class="nav-icon i-File-Clipboard-Text--Image"></i
            ><span class="item-name">Mileage</span
            ><i class="dd-arrow i-Arrow-Down"></i
          ></a>
          <ul class="submenu">
            <li><router-link to="/newmileage">New mileage</router-link></li>
            <li>
              <router-link to="/managemileages">Manage mileage</router-link>
            </li>
            <li>
              <router-link to="/managedrivers">Manage drivers</router-link>
            </li>
          </ul>
        </li>
      </ul>
      <ul class="childNav" data-parent="trips">
        <li class="nav-item dropdown-sidemenu">
          <a href=""
            ><i class="nav-icon i-File-Clipboard-Text--Image"></i
            ><span class="item-name">Trips</span
            ><i class="dd-arrow i-Arrow-Down"></i
          ></a>
          <ul class="submenu">
            <li><router-link to="/newtrip">New trip</router-link></li>
            <li>
              <router-link to="/managetrips">Manage trips</router-link>
            </li>
            <li>
              <router-link to="/newfuel">New fuel</router-link>
            </li>
            <li>
              <router-link to="/managefuels">Manage fuels</router-link>
            </li>
            <li>
              <router-link to="/addparking">New parking</router-link>
            </li>
            <li>
              <router-link to="/manageparkings">Manage parking</router-link>
            </li>
          </ul>
        </li>
      </ul>
      <ul class="childNav" data-parent="accounts">
        <li class="nav-item dropdown-sidemenu">
          <a href=""
            ><i class="nav-icon i-File-Clipboard-Text--Image"></i
            ><span class="item-name">Accounttypes</span
            ><i class="dd-arrow i-Arrow-Down"></i
          ></a>
          <ul class="submenu">
            <li>
              <router-link to="/newaccount">New account type</router-link>
            </li>
            <li>
              <router-link to="/manageaccounttypes"
                >Manage account types</router-link
              >
            </li>
          </ul>
        </li>
        <li class="nav-item dropdown-sidemenu">
          <a href=""
            ><i class="nav-icon i-File-Clipboard-Text--Image"></i
            ><span class="item-name">Money allocation</span
            ><i class="dd-arrow i-Arrow-Down"></i
          ></a>
          <ul class="submenu">
            <li><router-link to="/Allocations">Add pettycash</router-link></li>
          </ul>
        </li>
        <li class="nav-item dropdown-sidemenu">
          <a href=""
            ><i class="nav-icon i-File-Clipboard-Text--Image"></i
            ><span class="item-name">purchases</span
            ><i class="dd-arrow i-Arrow-Down"></i
          ></a>
          <ul class="submenu">
            <li>
              <router-link to="/managepurchases">Manage purchases</router-link>
            </li>
          </ul>
        </li>
        <li class="nav-item dropdown-sidemenu">
          <a href=""
            ><i class="nav-icon i-File-Clipboard-Text--Image"></i
            ><span class="item-name">Expenses</span
            ><i class="dd-arrow i-Arrow-Down"></i
          ></a>
          <ul class="submenu">
            <li><router-link to="/newexpenses">New expense</router-link></li>
            <li>
              <router-link to="/manageexpenses">Manage expenses</router-link>
            </li>
          </ul>
        </li>
        <li class="nav-item dropdown-sidemenu">
          <a href=""
            ><i class="nav-icon i-File-Clipboard-Text--Image"></i
            ><span class="item-name">Labour</span
            ><i class="dd-arrow i-Arrow-Down"></i
          ></a>
          <ul class="submenu">
            <li>
              <router-link to="/managelabourcharges">Manage labour</router-link>
            </li>
          </ul>
        </li>
      </ul>
      <ul class="childNav" data-parent="reports">
        <li class="nav-item">
          <router-link to="/trucksales"
            ><i class="nav-icon i-File-Clipboard-Text--Image"></i
            ><span class="item-name">Truck sales</span></router-link
          >
        </li>
        <li class="nav-item">
          <router-link to="/truckexpenses"
            ><i class="nav-icon i-File-Clipboard-Text--Image"></i
            ><span class="item-name">Truck expenses</span></router-link
          >
        </li>
        <li class="nav-item">
          <router-link to="/productsales"
            ><i class="nav-icon i-File-Clipboard-Text--Image"></i
            ><span class="item-name">Product sales</span></router-link
          >
        </li>
        <li class="nav-item">
          <router-link to="/productpurchases"
            ><i class="nav-icon i-File-Clipboard-Text--Image"></i
            ><span class="item-name">Product purchases</span></router-link
          >
        </li>
        <li class="nav-item">
          <router-link to="/suppliergoods"
            ><i class="nav-icon i-File-Clipboard-Text--Image"></i
            ><span class="item-name">Supplier goods</span></router-link
          >
        </li>
        <li class="nav-item">
          <router-link to="/labourcharges"
            ><i class="nav-icon i-File-Clipboard-Text--Image"></i
            ><span class="item-name">Labour charges</span></router-link
          >
        </li>
        <li class="nav-item">
          <router-link to="/summary"
            ><i class="nav-icon i-File-Clipboard-Text--Image"></i
            ><span class="item-name">Truck summary</span></router-link
          >
        </li>
      </ul>
    </div>
    <div class="sidebar-overlay"></div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  computed: mapGetters(["roleuserModules"]),
};
</script>


// WEBPACK FOOTER //
// src/layouts/sidebar.vue